import { memo } from "react";
import propTypes from "prop-types";
import "./AccommodationSummary.scss";
import classNames from "classnames";
import BedIcon from "app/pages/.shared/IconNegoBed";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { FormattedMessage, FormattedDate } from "react-intl";
import MealIcon from "app/pages/.shared/IconNegoDinner";
import InfoPopover from "app/pages/HotelOnly/components/Popover/InfoPopover";

const AccommodationSummary = ({
	accommodationType = "",
	boardType = "",
	freeCancellationDeadline = "",
	hasLeftDivider = false,
}) => {
	const parsedFreeCancellationDeadline = new Date(freeCancellationDeadline);
	const isCancellationDeadlineValid = !isNaN(parsedFreeCancellationDeadline.getTime());
	const shouldDisplayFreeCancellation =
		freeCancellationDeadline?.length > 0 && isCancellationDeadlineValid;

	const accommodationSummaryClassName = classNames("accommodation-summary", {
		"accommodation-summary--has-left-border": hasLeftDivider,
	});

	return (
		<div className={accommodationSummaryClassName} data-testid="accommodation-summary">
			{accommodationType?.length > 0 && (
				<div className="accommodation-summary__accommodation-type">
					<BedIcon width={16} height={16} aria-hidden="true" />
					<Typography
						variant={TYPOGRAPHY_VARIANTS.REGULAR}
						component="p"
						data-testid="detail-accommodation"
					>
						{accommodationType}
					</Typography>
				</div>
			)}

			{boardType?.length > 0 && (
				<div className="accommodation-summary__board-type">
					<MealIcon width={16} height={16} aria-hidden="true" />
					<Typography
						variant={TYPOGRAPHY_VARIANTS.REGULAR}
						component="p"
						data-testid="detail-board"
					>
						{boardType}
					</Typography>
				</div>
			)}

			{shouldDisplayFreeCancellation && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.REGULAR}
					className="accommodation-summary__free-cancellation-deadline"
					component="p"
				>
					{/* eslint-disable */}
					<FormattedMessage
						id={"listing.product.cancellation.policy"}
						values={{
							b: chunks => <strong>{chunks}</strong>,
							endDate: (
								<FormattedDate
									value={parsedFreeCancellationDeadline}
									year="numeric"
									month="short"
									day="2-digit"
									weekday="short"
								/>
							),
						}}
					/>

					<InfoPopover
						portal
						classNamePrefix="accommodation-summary__free-cancellation-deadline"
					>
						<div className="accommodation-summary__free-cancellation-deadline-popover-content">
							<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} component="span">
								<FormattedMessage id="price.detail.free.cancellation.label" />
							</Typography>
						</div>
					</InfoPopover>
				</Typography>
			)}
		</div>
	);
};

AccommodationSummary.propTypes = {
	accommodationType: propTypes.string,
	boardType: propTypes.string,
	freeCancellationDeadline: propTypes.string,
	hasLeftDivider: propTypes.bool,
};

export default memo(AccommodationSummary);
